import React, { useId, useMemo } from 'react'
import '../Settings/settings.css'
import { Button, Tooltip, message } from 'antd'
import { CopyOutlined } from '@ant-design/icons'
import { useAuth } from '../../context/AuthProvider'

/**
 * “Active brand” summary (name + ID + copy), same as the top of the Brand settings tab.
 */
export default function ActiveBrandBlock() {
  const headingId = useId()
  const { brandId, brands, brandIdLoaded } = useAuth()

  const currentBrand = useMemo(() => {
    if (!brandId || !brands?.length) return { id: null, name: null }
    return brands.find((b) => b.id === brandId) ?? { id: brandId, name: null }
  }, [brandId, brands])

  const usingLabel = currentBrand.name ?? (brandIdLoaded && !brandId ? 'No brand selected' : '—')
  const idLabel = currentBrand.id ?? '—'

  const copyBrandId = async () => {
    if (!brandId) return
    try {
      await navigator.clipboard.writeText(brandId)
      message.success('Brand ID copied')
    } catch {
      message.error('Could not copy')
    }
  }

  return (
    <section className="brand-workspace__section" aria-labelledby={headingId}>
      <h2 id={headingId} className="brand-workspace__heading">
        Active brand
      </h2>
      <p className="brand-workspace__meta-line">
        <span className="brand-workspace__label-inline">Currently using:</span> {usingLabel}
      </p>
      <p className="brand-workspace__meta-line">
        <span className="brand-workspace__label-inline">Brand ID:</span>{' '}
        <span className="brand-workspace__uid-inline">
          <code className="brand-workspace__code">{idLabel}</code>
          <Tooltip title="Copy brand ID">
            <Button
              type="text"
              size="small"
              className="brand-workspace__copy-uid"
              icon={<CopyOutlined />}
              onClick={copyBrandId}
              disabled={!brandId}
              aria-label="Copy brand ID"
            />
          </Tooltip>
        </span>
      </p>
    </section>
  )
}
